export function show(element) {
    if (!element) {
        return;
    }
    
    if (element.style !== undefined && element.style.display !== 'none') {
        element.dataset.styleShow = element.style.display;
    }
    
    element.style.display = element.dataset.styleShow !== undefined ? element.dataset.styleShow : 'block';
}

export function hide(element) {
    if (!element) {
        return;
    }
    
    if (element.display !== undefined && element.style.display !== 'none') {
        element.dataset.styleShow = element.style.display;
    }
    
    element.style.display = 'none';
}

export function log(message) {
    console.warn(message);
}